// HKDSE 2025 Paper 1 Knowledge Graph Samples - Part 4
// Final part with remaining questions from the LaTeX file

export const hkdse2025Samples_part4 = {
  probability: [
    {
      id: 'hkdse2025_probability_01',
      problem: "某盒子內有 $8$ 隻白色碟、$4$ 隻紅色碟及 $1$ 隻黑色碟。若從該盒子中隨機同時抽出 $3$ 隻碟，求 (a) 所抽出 $3$ 隻碟的顏色是相同的概率；(b) 所抽出 $3$ 隻碟的顏色是全不相同的概率。",
      problemType: "probability_combinations",
      difficulty: "intermediate",
      description: "Calculating probabilities using combinations",
      graphData: {
        nodes: [
          {
            id: "ball_distribution",
            name: "Ball Distribution",
            type: "concepts",
            description: "Number of balls of each color",
            value: "White: 8, Red: 4, Black: 1",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "total_balls",
            name: "Total Balls",
            type: "concepts",
            description: "Total number of balls",
            value: "Total = 8 + 4 + 1 = 13",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_same_color",
            name: "Part (a): Same Color",
            type: "steps",
            description: "Calculate P(3 balls same color)",
            value: "P(same) = P(3 white) + P(3 red)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_white_probability",
            name: "Part (a): White Probability",
            type: "steps",
            description: "P(3 white balls)",
            value: "P(3 white) = C(8,3)/C(13,3)",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_red_probability",
            name: "Part (a): Red Probability",
            type: "steps",
            description: "P(3 red balls)",
            value: "P(3 red) = C(4,3)/C(13,3)",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_different_colors",
            name: "Part (b): Different Colors",
            type: "steps",
            description: "Calculate P(3 different colors)",
            value: "P(different) = P(1 white, 1 red, 1 black)",
            importance: 9,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_b_calculation",
            name: "Part (b): Calculation",
            type: "steps",
            description: "Calculate the probability",
            value: "P(different) = (8×4×1)/C(13,3)",
            importance: 8,
            x: 200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "Both probabilities",
            value: "(a) P(same) = calculated value (b) P(different) = calculated value",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "ball_distribution", to: "total_balls", type: "enables", strength: 9 },
          { from: "total_balls", to: "part_a_same_color", type: "enables", strength: 9 },
          { from: "part_a_same_color", to: "part_a_white_probability", type: "enables", strength: 8 },
          { from: "part_a_same_color", to: "part_a_red_probability", type: "enables", strength: 8 },
          { from: "part_a_white_probability", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_a_red_probability", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "ball_distribution", to: "part_b_different_colors", type: "enables", strength: 9 },
          { from: "part_b_different_colors", to: "part_b_calculation", type: "leads_to", strength: 8 },
          { from: "part_b_calculation", to: "final_answers", type: "contributes_to", strength: 8 }
        ]
      }
    }
  ],
  
  logarithms: [
    {
      id: 'hkdse2025_logarithms_01',
      problem: "已知 $\\begin{cases} \\log_3 x + \\log_3 y = 9 \\\\ \\log_y 81 - \\log_y 9 = 1 \\end{cases}$，其中 $0 < x < y$。(a) 設 $u = \\log_3 y$。證明 $u^2 - 3u - 18 = 0$。(b) 求 $x$。",
      problemType: "logarithms_system_equations",
      difficulty: "intermediate",
      description: "Solving system of logarithmic equations",
      graphData: {
        nodes: [
          {
            id: "system_equations",
            name: "System of Equations",
            type: "concepts",
            description: "Two logarithmic equations",
            value: "log₃x + log₃y = 9, logᵧ81 - logᵧ9 = 1",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "logarithm_properties",
            name: "Logarithm Properties",
            type: "concepts",
            description: "Properties of logarithms",
            value: "logₐb + logₐc = logₐ(bc), logₐb - logₐc = logₐ(b/c)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_substitution",
            name: "Part (a): Substitution",
            type: "steps",
            description: "Let u = log₃y",
            value: "u = log₃y",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_first_equation",
            name: "Part (a): First Equation",
            type: "steps",
            description: "Simplify first equation",
            value: "log₃x + u = 9 → log₃x = 9 - u",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_second_equation",
            name: "Part (a): Second Equation",
            type: "steps",
            description: "Simplify second equation",
            value: "logᵧ81 - logᵧ9 = logᵧ(81/9) = logᵧ9 = 1",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_a_convert_base",
            name: "Part (a): Convert Base",
            type: "steps",
            description: "Convert logᵧ9 to base 3",
            value: "logᵧ9 = log₃9/log₃y = 2/u",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_a_quadratic_equation",
            name: "Part (a): Quadratic Equation",
            type: "steps",
            description: "Form the quadratic equation",
            value: "2/u = 1 → u = 2, but also u = log₃y",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_b_find_x",
            name: "Part (b): Find x",
            type: "steps",
            description: "Use u value to find x",
            value: "x = 3^(9-u)",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "Proof and value of x",
            value: "(a) u² - 3u - 18 = 0 (b) x = calculated value",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "system_equations", to: "logarithm_properties", type: "enables", strength: 9 },
          { from: "logarithm_properties", to: "part_a_substitution", type: "enables", strength: 8 },
          { from: "part_a_substitution", to: "part_a_first_equation", type: "enables", strength: 8 },
          { from: "part_a_first_equation", to: "part_a_second_equation", type: "enables", strength: 8 },
          { from: "part_a_second_equation", to: "part_a_convert_base", type: "leads_to", strength: 9 },
          { from: "part_a_convert_base", to: "part_a_quadratic_equation", type: "leads_to", strength: 9 },
          { from: "part_a_quadratic_equation", to: "part_b_find_x", type: "enables", strength: 8 },
          { from: "part_b_find_x", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_a_quadratic_equation", to: "final_answers", type: "contributes_to", strength: 9 }
        ]
      }
    }
  ],
  
  sequences: [
    {
      id: 'hkdse2025_sequences_01',
      problem: "設 $T(n)$ 為一等差數列的第 $n$ 項使得 $T(1) \\neq T(2)$ 及 $T(47) = 456$。已知 $T(9), T(47), T(199)$ 為一等比數列。(a) 求 $T(1)$。(b) 求 $n$ 的最小值使得該等差數列的首 $n$ 項之和大於 $10^6$。",
      problemType: "sequences_arithmetic_geometric",
      difficulty: "intermediate",
      description: "Working with arithmetic and geometric sequences",
      graphData: {
        nodes: [
          {
            id: "arithmetic_sequence",
            name: "Arithmetic Sequence",
            type: "concepts",
            description: "T(n) is arithmetic sequence",
            value: "T(n) = a + (n-1)d",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_conditions",
            name: "Given Conditions",
            type: "concepts",
            description: "Specific terms and conditions",
            value: "T(1) ≠ T(2), T(47) = 456",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "geometric_condition",
            name: "Geometric Condition",
            type: "concepts",
            description: "T(9), T(47), T(199) form geometric sequence",
            value: "[T(47)]² = T(9) × T(199)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_setup_equations",
            name: "Part (a): Setup Equations",
            type: "steps",
            description: "Set up equations using given conditions",
            value: "T(47) = a + 46d = 456",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_geometric_equation",
            name: "Part (a): Geometric Equation",
            type: "steps",
            description: "Use geometric sequence condition",
            value: "456² = (a + 8d)(a + 198d)",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_a_solve_system",
            name: "Part (a): Solve System",
            type: "steps",
            description: "Solve the system of equations",
            value: "Find a and d values",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_sum_condition",
            name: "Part (b): Sum Condition",
            type: "steps",
            description: "Find n where sum > 10⁶",
            value: "S(n) = n/2[2a + (n-1)d] > 10⁶",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_b_solve_inequality",
            name: "Part (b): Solve Inequality",
            type: "steps",
            description: "Solve the quadratic inequality",
            value: "Find minimum n satisfying the condition",
            importance: 9,
            x: 200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "T(1) and minimum n",
            value: "(a) T(1) = calculated value (b) n = calculated value",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "arithmetic_sequence", to: "given_conditions", type: "enables", strength: 9 },
          { from: "given_conditions", to: "geometric_condition", type: "enables", strength: 9 },
          { from: "geometric_condition", to: "part_a_setup_equations", type: "enables", strength: 8 },
          { from: "part_a_setup_equations", to: "part_a_geometric_equation", type: "leads_to", strength: 9 },
          { from: "part_a_geometric_equation", to: "part_a_solve_system", type: "leads_to", strength: 9 },
          { from: "part_a_solve_system", to: "part_b_sum_condition", type: "enables", strength: 8 },
          { from: "part_b_sum_condition", to: "part_b_solve_inequality", type: "leads_to", strength: 9 },
          { from: "part_a_solve_system", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "part_b_solve_inequality", to: "final_answers", type: "contributes_to", strength: 9 }
        ]
      }
    }
  ],
  
  quadratic_advanced: [
    {
      id: 'hkdse2025_quadratic_advanced_01',
      problem: "設 $g(x) = 3x^2 - 6kx + 24x + 3k^2 - 24k + 55$，其中 $k$ 為一正常數。將 $y = g(x)$ 的圖像的頂點記為 $R$。(a) 利用配方法，以 $k$ 表 $R$ 的坐標。(b) 藉將 $y = g(x)$ 的圖像向右平移 $6$ 單位，然後向下平移 $10$ 單位得出 $y = h(x)$ 的圖像。將 $y = h(x)$ 的圖像的頂點記為 $S$。設 $T$ 為一點使得 $\\triangle RST$ 的垂心為原點。(i) 以 $k$ 表 $T$ 的坐標。(ii) 點 $U$ 的坐標為 $(-5, 5)$。設 $V$ 為 $RS$ 上的一點使得 $TV$ 垂直於 $RS$。已知 $S$、$T$、$U$ 與 $V$ 共圓。求 $k$。",
      problemType: "quadratic_completing_square_geometry",
      difficulty: "advanced",
      description: "Advanced quadratic functions with geometric applications",
      graphData: {
        nodes: [
          {
            id: "quadratic_function",
            name: "Quadratic Function",
            type: "concepts",
            description: "g(x) = 3x² - 6kx + 24x + 3k² - 24k + 55",
            value: "Quadratic function with parameter k",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "completing_square",
            name: "Completing the Square",
            type: "methods",
            description: "Complete the square to find vertex",
            value: "g(x) = 3(x - k + 4)² + (55 - 3(k-4)²)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "vertex_coordinates",
            name: "Vertex Coordinates",
            type: "steps",
            description: "Find coordinates of vertex R",
            value: "R(k-4, 55 - 3(k-4)²)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "transformation",
            name: "Transformation",
            type: "concepts",
            description: "Translate right 6, down 10",
            value: "h(x) = g(x-6) - 10",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "vertex_s_coordinates",
            name: "Vertex S Coordinates",
            type: "steps",
            description: "Find coordinates of vertex S",
            value: "S(k+2, 45 - 3(k-4)²)",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "orthocenter_condition",
            name: "Orthocenter Condition",
            type: "concepts",
            description: "Orthocenter of triangle RST is origin",
            value: "Use orthocenter properties",
            importance: 9,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_bi_find_t",
            name: "Part (b)(i): Find T",
            type: "steps",
            description: "Find coordinates of point T",
            value: "Use orthocenter condition to find T",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_bii_circle_condition",
            name: "Part (b)(ii): Circle Condition",
            type: "steps",
            description: "S, T, U, V are concyclic",
            value: "Use concyclic points condition",
            importance: 8,
            x: 200, y: 200, z: 0
          },
          {
            id: "part_bii_solve_k",
            name: "Part (b)(ii): Solve for k",
            type: "steps",
            description: "Solve for the value of k",
            value: "Use geometric conditions to find k",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required answers",
            value: "(a) R coordinates in terms of k (b)(i) T coordinates (b)(ii) k = calculated value",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "quadratic_function", to: "completing_square", type: "enables", strength: 9 },
          { from: "completing_square", to: "vertex_coordinates", type: "leads_to", strength: 9 },
          { from: "vertex_coordinates", to: "transformation", type: "enables", strength: 8 },
          { from: "transformation", to: "vertex_s_coordinates", type: "leads_to", strength: 8 },
          { from: "vertex_s_coordinates", to: "orthocenter_condition", type: "enables", strength: 9 },
          { from: "orthocenter_condition", to: "part_bi_find_t", type: "leads_to", strength: 9 },
          { from: "part_bi_find_t", to: "part_bii_circle_condition", type: "enables", strength: 8 },
          { from: "part_bii_circle_condition", to: "part_bii_solve_k", type: "leads_to", strength: 9 },
          { from: "vertex_coordinates", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "part_bi_find_t", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "part_bii_solve_k", to: "final_answers", type: "contributes_to", strength: 9 }
        ]
      }
    }
  ],
  
  circle_geometry_advanced: [
    {
      id: 'hkdse2025_circle_geometry_advanced_01',
      problem: "直線 $L$ 的方程為 $4x - 3y + 83 = 0$。圓 $C$ 的方程為 $x^2 + y^2 + ax - 2y + b = 0$，其中 $a$ 及 $b$ 均為正常數。已知 $C$ 通過點 $(-10, 9)$ 且 $L$ 為 $C$ 的切線。(a) 證明方程 $25x^2 + (9a + 640)x + (90a + 4924) = 0$ 有等根。由此，求 $a$ 及 $b$。(b) 點 $P$ 的坐標為 $(-20, 1)$。設 $Q$ 為在 $L$ 之下的一點使得 $PQ$ 與 $C$ 相切且 $PQ = 25$。將 $C$ 的圓心記為 $I$。(i) 求 $\\cos \\angle IPQ$。(ii) 求 $I$ 與 $Q$ 間的距離，答案以根式表示。(iii) 設 $R$ 為 $L$ 上的一點使得 $C$ 為 $\\triangle PQR$ 的內切圓。將 $\\triangle PQR$ 的外接圓的半徑記為 $r$。某人宣稱 $r > PQ$。該宣稱是否正確？試解釋你的答案。",
      problemType: "circle_geometry_advanced",
      difficulty: "advanced",
      description: "Advanced circle geometry with tangent lines and inscribed circles",
      graphData: {
        nodes: [
          {
            id: "line_equation",
            name: "Line Equation",
            type: "concepts",
            description: "L: 4x - 3y + 83 = 0",
            value: "Line L is tangent to circle C",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "circle_equation",
            name: "Circle Equation",
            type: "concepts",
            description: "C: x² + y² + ax - 2y + b = 0",
            value: "Circle with unknown coefficients a, b",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "given_conditions",
            name: "Given Conditions",
            type: "concepts",
            description: "C passes through (-10,9) and L is tangent",
            value: "Point condition and tangent condition",
            importance: 10,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_equal_roots",
            name: "Part (a): Equal Roots",
            type: "steps",
            description: "Show quadratic has equal roots",
            value: "Use discriminant = 0",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_solve_ab",
            name: "Part (a): Solve for a, b",
            type: "steps",
            description: "Solve for coefficients a and b",
            value: "Use point condition and tangent condition",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_tangent_condition",
            name: "Part (b): Tangent Condition",
            type: "steps",
            description: "PQ is tangent to circle C",
            value: "Use tangent properties",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_bi_cosine_angle",
            name: "Part (b)(i): Cosine Angle",
            type: "steps",
            description: "Find cos ∠IPQ",
            value: "Use cosine formula",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_bii_distance",
            name: "Part (b)(ii): Distance",
            type: "steps",
            description: "Find distance between I and Q",
            value: "Use distance formula",
            importance: 8,
            x: 200, y: 200, z: 0
          },
          {
            id: "part_biii_inscribed_circle",
            name: "Part (b)(iii): Inscribed Circle",
            type: "steps",
            description: "C is inscribed circle of triangle PQR",
            value: "Use inscribed circle properties",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "part_biii_circumradius",
            name: "Part (b)(iii): Circumradius",
            type: "steps",
            description: "Find circumradius r and compare with PQ",
            value: "r = abc/(4×area)",
            importance: 9,
            x: 0, y: 300, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required answers",
            value: "(a) a = value, b = value (b)(i) cos value (b)(ii) distance (b)(iii) Yes/No with explanation",
            importance: 10,
            x: 0, y: 350, z: 0
          }
        ],
        links: [
          { from: "line_equation", to: "given_conditions", type: "enables", strength: 9 },
          { from: "circle_equation", to: "given_conditions", type: "enables", strength: 9 },
          { from: "given_conditions", to: "part_a_equal_roots", type: "enables", strength: 9 },
          { from: "part_a_equal_roots", to: "part_a_solve_ab", type: "leads_to", strength: 9 },
          { from: "part_a_solve_ab", to: "part_b_tangent_condition", type: "enables", strength: 8 },
          { from: "part_b_tangent_condition", to: "part_bi_cosine_angle", type: "enables", strength: 8 },
          { from: "part_b_tangent_condition", to: "part_bii_distance", type: "enables", strength: 8 },
          { from: "part_b_tangent_condition", to: "part_biii_inscribed_circle", type: "enables", strength: 9 },
          { from: "part_biii_inscribed_circle", to: "part_biii_circumradius", type: "leads_to", strength: 9 },
          { from: "part_a_solve_ab", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "part_bi_cosine_angle", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_bii_distance", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_biii_circumradius", to: "final_answers", type: "contributes_to", strength: 9 }
        ]
      }
    }
  ]
}; 